export default __webpack_public_path__ + "static/media/shape-arrow.ecb0b31c.svg";